<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('user.yuebao')}}</div>
        </div>
        <div class="user_yw">
            <p>{{ userRate }}</p>
            <p>{{$t('user.yuebao_money')}}</p>
        </div>
        <div class="user_zrzc2">
            <span>{{$t('user.total_income')}}:{{funds}}{{$t('user.moneyUnit')}}</span>
            <span>{{$t('user.daily_income_rate')}}: {{ rate }}%</span>
        </div>

        <div class="user_transfer_box">
            <div class="dropdown">{{$t('user.enter_amount')}}</div>
            <input type="number" style="background: #FFF;" v-model="transferAmount" :placeholder="$t('user.enter_amount')" class="transfer_input" />
            <div class="transfer_buttons">
                <span  style="background: #000;"  @click="transferIn">{{$t('moneybag.recharge')}}</span>
                <span @click="transferOut">{{$t('moneybag.withdraw')}}</span>
            </div>
            <div style="font-size: 16px;margin-top: 28px; margin-bottom: 5px; background: #fff; padding: 14px;">近{{ totalCount }}笔收益记录</div>            
        </div>
        
        <!-- <div class="user_zrzc">
            <span @click="$router.push('/invest')">{{$t('moneybag.recharge')}}</span>
            <span @click="$router.push('/cash')">{{$t('moneybag.withdraw')}}</span>
        </div> -->
        <van-empty :description="$t('moneybag.detailsEmpty')" v-if="listShow" />
        <div class="detail_box">
            <div class="item" v-for="item in data">
                <div class="de_wrap">
                    <p class="tit">{{item[lang]}}</p>
                    <p class="time">{{item.time}}<span style="margin-left: 10px;">收益</span></p>
                </div>
                <div class="price" style="font-size: 15px;" :class="item.type =='0'?'':'del'" v-html="item.type =='0'?item.money + '元' : '-'+ item.money+ '元' "></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem
    } from 'vant';

    import { Empty, Toast } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem);
    Vue.use(Toast);

    export default {
        name: "moneybag",
        data() {
            return {
                lang: this.$i18n.locale || "zh_cn",
                data: [],
                list: {},
                option: [],
                listShow: false,
                transferAmount: null, // Added for transfer input，
                funds: 0, // 累计收益
                userRate: 0, // 余额宝余额
                rate: 0, // 日化率
                totalCount: 0 // 记录条数
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.fetchFundsData();
        },
        methods: {
            fetchFundsData() {
                Fetch('/user/yuebao_list').then(r => {
                    this.option = [{
                    text: this.$t('moneybag.types'),
                    value: 0
                    }];

                    this.showError(r.data.list.length);
                    this.data = r.data.list;
                    this.funds = r.data.money;

                    const { user_rate, rate, total_count } = r.data;
                    this.userRate = user_rate;
                    this.rate = rate;
                    this.totalCount = total_count;
                });
            },
        
            showError(len) {
                len == 0 ? this.listShow = true : this.listShow = false;
            },
            validateAmount() {
                if (!this.transferAmount || isNaN(this.transferAmount) || parseFloat(this.transferAmount) <= 0) {
                    Toast(this.$t('user.enter_amount'));
                    return false;
                }
                return true;
            },
            transferIn() {
                if (!this.validateAmount()) return;
                Fetch('/user/yuebao', {
                    money: this.transferAmount,
                    type: 1 // 1 for transfer in
                }).then(r => {
                    Toast.success(this.$t('user.transfer_in_success'));
                    this.transferAmount = null; // Clear input
                    this.fetchFundsData(); // Refresh data
                }).catch(e => {
                     // Error handling is already done by Fetch utility
                });
            },
            transferOut() {
                if (!this.validateAmount()) return;
                Fetch('/user/yuebao', {
                    money: this.transferAmount,
                    type: 2 // 2 for transfer out
                }).then(r => {
                    Toast.success(this.$t('user.transfer_out_success'));
                    this.transferAmount = null; // Clear input
                    this.fetchFundsData(); // Refresh data
                }).catch(e => {
                    // Error handling is already done by Fetch utility
                });
            }
        }
    };
</script>

<style lang="less" scoped>
    #app{
        background-color: #fff !important;
    }
    #left_click{
        background: #000;
    }
    .red_top_bg {
        height: 380px;
        background: #3775f4;
        position: fixed;
    }
    .dropdown{
        text-align: left;
        color: #fff;
        margin-bottom: 10px;
        font-size: 15px;
    }
    .user_yw {
        text-align: center;
        width: 96%;
        position: absolute;
        top: 60px;
        left: 2%;
        border-radius: 5px 5px 0 0;
        padding: 20px 0;

        p:nth-child(1) {
            font-size: 36px;
            color: #ffffff;
            margin-bottom: 16px;
        }

        p {
            color: #ffffff;
        }

        p:nth-child(2) {
            font-size: 16px;
            /* font-weight: bold; */
        }
    }

    .user_zrzc2 {
        font-size: 16px;
        text-align: center;
        width: 96%;
        position: absolute;
        top: 166px; /* Adjusted to give space for button */
        left: 2%;
        padding: 20px 0;
        display: flex;
        justify-content: space-around; /* Changed to space-around for better distribution */
        text-align: center;

        span {
            color: #FFFFFF;
        }
    }

    .user_transfer_box {
        width: 96%;
        position: absolute;
        top: 210px; /* Positioned between the two existing divs */
        left: 2%;
        border-radius: 5px;
        padding: 15px;
        text-align: center;
        box-sizing: border-box;

        .transfer_input {
            width: 60%;
            padding: 10px;
            border: 1px solid #ddd;
            border-radius: 5px;
            font-size: 16px;
            margin-bottom: 22px;
            box-sizing: border-box;
        }

        .transfer_buttons {
            display: flex;
            justify-content: space-between;

            span {
                width: 48%; /* Adjusted width for two buttons */
                background: #ec6d3e;
                color: #FFFFFF;
                padding: 12px 10px;
                border-radius: 5px;
                cursor: pointer;
                font-size: 16px;
                box-sizing: border-box;
            }
        }
    }

    .user_zrzc {
        text-align: center;
        width: 96%;
        position: absolute;
        top: 410px; /* Adjusted to be below the new transfer box */
        left: 2%;
        border-radius: 0 0 5px 5px;
        padding: 15px 0;
        display: flex;
        justify-content: space-between;
        text-align: center;

        span {
            width: 40%;
            background: #ec6d3e;
            color: #FFFFFF;
            margin: 0px 20px;
            padding: 12px 10px;
            border-radius: 5px;
        }
    }

    .detail_box {
        width: 96%;
        margin-left: 2%;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        padding: 0 8px;
        margin-top: 420px; /* Adjusted to accommodate the new transfer box */

        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 8px;
            border-bottom: 1px solid #ECECEC;

            .de_wrap {
                flex: 2;

                .tit {
                    font-size: 14px;
                    color: rgba(0, 0, 0, .8);
                    line-height: 18px;
                }

                .time {
                    font-size: 14px;
                    color: rgba(0, 0, 0, .8);
                    line-height: 17px;
                    margin-top: 10px;
                }
            }

            .price {
                flex: 1;
                font-size: 18px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #f12211;
                white-space: nowrap;

                &.del {
                    color: #3FAF3E;
                }
            }
        }
    }
</style>
